import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { PlanWithLimits } from '../models/plans';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-phone-number-settings'
})
export class Ng1PhoneNumberSettingsDirective extends UpgradeComponent {
  @Input() number;
  @Input() msisdn;
  @Input() plan: PlanWithLimits;
  @Input() hasAutoAppliedEeaMsisdn: boolean;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('numberSettings', elementRef, injector);
  }
}
